import { useEffect, useState } from 'react'
import { InspectionVariableFeeTemplate } from '../../../types/VariableFee'
import BackOfficeAPIClient from '../../../clients/BackofficeAPIClient'

const backofficeApiClient = new BackOfficeAPIClient()

export interface VariableFeeRawData {
    data: InspectionVariableFeeTemplate[]
    loading: boolean
    refetch: () => Promise<void>
}

/**
 * Toutes les lignes (global + par site + par marque), pour calculer les valeurs par défaut en
 * mode config multi-sites/multi-marques. `refetch` doit être appelé après chaque enregistrement
 * (cf. VariableFees.tsx) : sans ça, si l'utilisateur enregistre puis change de sélection sans
 * recharger la page, la fusion/le repli exact-combo utiliserait des données périmées.
 */
export function useVariableFeeRawData(): VariableFeeRawData {
    const [ data, setData ] = useState<InspectionVariableFeeTemplate[]>([])
    const [ loading, setLoading ] = useState(true)

    const fetchData = async () => {
        setLoading(true)
        try {
            setData(await backofficeApiClient.get<InspectionVariableFeeTemplate[]>('/inspection-variable-fee-templates/overview'))
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchData()
    }, [])

    return { data, loading, refetch: fetchData }
}
